var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIkonaChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.046,
    viewBox: "0 0 15 14.046"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.5a5.232 5.232 0 00-1 .5c-.341.206-.069-.337 0-.5 0 0 .2-.624.263-.811v-.01c.217-.629-.043-1.271.022-1.945A5.945 5.945 0 01-.003 6.625C-.003 3.242 3.631 0 7.497 0s7.5 3.242 7.5 6.625S11.362 13 7.497 13a8.794 8.794 0 01-2.169-.25 12.512 12.512 0 01-2.828.75zm.343-3.467a.877.877 0 01.252.7 9.693 9.693 0 01-.349 1.75 10.417 10.417 0 002.3-.782.869.869 0 01.621-.064 7.1 7.1 0 001.828.237c3.5 0 6.125-2.456 6.125-5.25s-2.629-5.25-6.125-5.25S1.37 3.831 1.37 6.624a4.811 4.811 0 001.473 3.409z",
    fill: "#750b22"
  })));
}

export default SvgIkonaChat;